import { t } from 'i18next';
/**
 * Formats a total number of days into weeks and days.
 * @param {number} totalDays - The total number of days to format.
 * @returns {string} A string representing the formatted weeks and days.
 */

const formatWeeksAndDays = totalDays => {
  const weeks = Math.floor(totalDays / 7);
  const days = totalDays % 7;

  // eslint-disable-next-line no-nested-ternary
  const weekStr = weeks === 1 ? `1 ${ t('products.week') }` : weeks > 1 ? `${weeks} ${ t('products.weeks') }` : '';
  // eslint-disable-next-line no-nested-ternary
  const dayStr = days === 1 ? `1 ${ t('products.day') }` : days > 1 ? `${days} ${ t('products.days') }` : '';

  if (weekStr && dayStr) {
    return `${ weekStr } ${ t('common.and') } ${ dayStr }`;
  // eslint-disable-next-line no-else-return
  } else if (weekStr) {
    return weekStr;
  } else if (dayStr) {
    return dayStr;
  } else {
    return '0 days';
  }
};

export default formatWeeksAndDays;
